import {
  ChoremeioFormConfig,
  FieldItem,
} from '@/configuration/components/choremeioFields.config';
import { CreatePatientField } from '@/pages/ainigma/CreatePatientField';
import { Divider, Group, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface PatientEditDemographicsFormProps {
  form: UseFormReturnType<any>;
  requiredFields: ChoremeioFormConfig['choremeioFieldsConfig'];
}

export const PatientEditDemographicsForm: FC<
  PatientEditDemographicsFormProps
> = ({ form, requiredFields }) => {
  const { t } = useTranslation(['common', 'create-patient-modal']);

  const formContent = (
    <Stack gap="md">
      {requiredFields.map((fieldConfig, index) => {
        if (fieldConfig.type === 'group') {
          return (
            <div key={index}>
              <Group grow preventGrowOverflow={true} align="flex-start">
                {fieldConfig.fields?.map((field, idx) => (
                  <CreatePatientField
                    key={`${index}-${idx}`}
                    field={field as FieldItem}
                    placeholderAppear={true}
                    form={form}
                  />
                ))}
              </Group>
            </div>
          );
        }
        if (fieldConfig.type === 'divider') {
          return (
            <Divider
              my="xs"
              label={t(`labels.${fieldConfig.label}`, 'Label', {
                ns: 'create-patient-modal',
              })}
              labelPosition="left"
            />
          );
        }

        if (fieldConfig.type === 'field') {
          return (
            <div key={index}>
              <CreatePatientField
                key={`${index}`}
                field={fieldConfig as FieldItem}
                placeholderAppear={true}
                form={form}
              />
            </div>
          );
        }
        return null;
      })}
    </Stack>
  );

  return formContent;
};
